import { Icon, Tab, Tabs } from "@blueprintjs/core"
import React, { ReactText } from "react"
import NoContract from "pages/vehicle/all/dialog/NoContract"
import VehicleDepartments from "pages/vehicle/all/dialog/VehicleDepartments"
import VehicleDetails from "pages/vehicle/all/dialog/VehicleDetails"
import VehicleExpense from "pages/vehicle/all/dialog/VehicleExpense"
import VehiclePayments from "pages/vehicle/all/dialog/VehiclePayments"
import VehicleStatus from "pages/vehicle/all/dialog/VehicleStatus"
import CustomDialog from "../Atoms/CustomDialog"

interface VehicleDetailsDialogProps {
  /**
   * isOpen - Denotes whether the vehicle dialog is open or not
   */
  isOpen: boolean
  onClose: () => void
  vehicle: any
  selectedTab: any
  onTabChange: (tab: ReactText) => void
}

const VehicleDetailsDialog = ({
  isOpen,
  onClose,
  vehicle,
  selectedTab,
  onTabChange,
}: VehicleDetailsDialogProps) => {
  const hasContract = vehicle?.currentContract?.id ? true : false

  return (
    <CustomDialog
      style={{
        minHeight: "70vh",
      }}
      icon="drive-time"
      light
      scrollable={false}
      width="60%"
      title={
        <span>
          <span className="vt-highlight">{vehicle?.registrationNumber}</span>
          <span className="vt-muted">- {vehicle?.vehicleType?.name}</span>
        </span>
      }
      isOpen={isOpen}
      onClose={onClose}
    >
      <Tabs selectedTabId={selectedTab} onChange={tab => onTabChange(tab)}>
        <Tab
          id="details"
          panel={<VehicleDetails id={vehicle?.id} />}
          title={
            <span>
              <Icon className="mr-2" iconSize={14} icon="drive-time" />
              <span>Details</span>
            </span>
          }
        />

        <Tab
          id="status"
          title={
            <span>
              <Icon className="mr-2" iconSize={14} icon="clean" />
              <span>Status</span>
            </span>
          }
          panel={<VehicleStatus vehicle={vehicle} />}
        />
        <Tab
          id="departments"
          title={
            <span>
              <Icon className="mr-2" iconSize={14} icon="briefcase" />
              <span>Departments</span>
            </span>
          }
          panel={<VehicleDepartments vehicle={vehicle} />}
        />
        <Tab
          id="payments"
          title={
            <span>
              <Icon className="mr-2" iconSize={14} icon="bank-account" />
              <span>Payments</span>
            </span>
          }
          panel={
            hasContract ? (
              <VehiclePayments vehicle={vehicle} />
            ) : (
              <NoContract vehicle={vehicle} />
            )
          }
        />
        <Tab
          id="expense"
          title={
            <span>
              <Icon className="mr-2" iconSize={14} icon="oil-field" />
              <span>Expenses</span>
            </span>
          }
          panel={
            hasContract ? (
              <VehicleExpense vehicle={vehicle} />
            ) : (
              <NoContract vehicle={vehicle} />
            )
          }
        />
      </Tabs>
    </CustomDialog>
  )
}

export default VehicleDetailsDialog
